<template>
    <svg
        width="660"
        height="440"
        viewBox="0 0 660 440"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 145C0 138.373 5.37258 133 12 133H147C153.627 133 159 138.373 159 145V390C159 396.627 153.627 402 147 402H12C5.37258 402 0 396.627 0 390V145Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M179 133.5H314C320.351 133.5 325.5 138.649 325.5 145V390C325.5 396.351 320.351 401.5 314 401.5H179C172.649 401.5 167.5 396.351 167.5 390V145C167.5 138.649 172.649 133.5 179 133.5Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M334 145C334 138.373 339.373 133 346 133H481C487.627 133 493 138.373 493 145V390C493 396.627 487.627 402 481 402H346C339.373 402 334 396.627 334 390V145Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M501 145C501 138.373 506.373 133 513 133H648C654.627 133 660 138.373 660 145V390C660 396.627 654.627 402 648 402H513C506.373 402 501 396.627 501 390V145Z"
            fill="var(--et-colors-card-background)"
        />
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="36"
            font-weight="600"
            letter-spacing="-0.01em"
        >
            <tspan x="272.338" y="58.2">Pricing</tspan>
        </text>
        <text
            fill="#475467"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="16"
            letter-spacing="0em"
        >
            <tspan x="228.398" y="90.2">Choose best option for you.</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="16" y="160.4">Base</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="24"
            letter-spacing="0em"
        >
            <tspan x="16" y="190.8">$29</tspan>
        </text>
        <path
            d="M24 262.5H135C139.142 262.5 142.5 265.858 142.5 270V286C142.5 290.142 139.142 293.5 135 293.5H24C19.8579 293.5 16.5 290.142 16.5 286V270C16.5 265.858 19.8579 262.5 24 262.5Z"
            stroke="var(--et-colors-border)"
        />
        <path
            d="M179 133.5H314C320.351 133.5 325.5 138.649 325.5 145V390C325.5 396.351 320.351 401.5 314 401.5H179C172.649 401.5 167.5 396.351 167.5 390V145C167.5 138.649 172.649 133.5 179 133.5Z"
            stroke="var(--et-colors-brand)"
        />
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="183" y="160.4">Standard</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="24"
            letter-spacing="0em"
        >
            <tspan x="183" y="190.8">$49</tspan>
        </text>
        <text
            fill="#667085"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
            text-decoration="line-through"
        >
            <tspan x="238" y="186.9">$59</tspan>
        </text>
        <path
            d="M191 262.5H302C306.142 262.5 309.5 265.858 309.5 270V286C309.5 290.142 306.142 293.5 302 293.5H191C186.858 293.5 183.5 290.142 183.5 286V270C183.5 265.858 186.858 262.5 191 262.5Z"
            fill="var(--et-colors-brand)"
        />
        <path
            d="M191 262.5H302C306.142 262.5 309.5 265.858 309.5 270V286C309.5 290.142 306.142 293.5 302 293.5H191C186.858 293.5 183.5 290.142 183.5 286V270C183.5 265.858 186.858 262.5 191 262.5Z"
            stroke="var(--et-colors-border)"
        />
        <text
            fill="var(--et-colors-card-background)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="221" y="282.3">Choose</tspan>
        </text>
        <path
            d="M274 121.5H219C212.649 121.5 207.5 126.649 207.5 133C207.5 139.351 212.649 144.5 219 144.5H274C280.351 144.5 285.5 139.351 285.5 133C285.5 126.649 280.351 121.5 274 121.5Z"
            fill="var(--et-colors-brand)"
        />
        <path
            d="M274 121.5H219C212.649 121.5 207.5 126.649 207.5 133C207.5 139.351 212.649 144.5 219 144.5H274C280.351 144.5 285.5 139.351 285.5 133C285.5 126.649 280.351 121.5 274 121.5Z"
            stroke="var(--et-colors-border)"
        />
        <text
            fill="var(--et-colors-card-background)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="217.297" y="136.9">Bestseller</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="350" y="160.4">Premium</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="24"
            letter-spacing="0em"
        >
            <tspan x="350" y="190.8">$69</tspan>
        </text>
        <text
            fill="#667085"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
            text-decoration="line-through"
        >
            <tspan x="405" y="186.9">$79</tspan>
        </text>
        <path
            d="M27.3337 334.667L20.667 341.333M20.667 334.667L27.3337 341.333M27.3337 354.667L20.667 361.333M20.667 354.667L27.3337 361.333M27.3337 374.667L20.667 381.333M20.667 374.667L27.3337 381.333M194.334 354.667L187.667 361.333M187.667 354.667L194.334 361.333M194.334 374.667L187.667 381.333M187.667 374.667L194.334 381.333M361.334 374.667L354.667 381.333M354.667 374.667L361.334 381.333"
            stroke="#D92D20"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="517" y="160.4">Enterprise</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="24"
            letter-spacing="0em"
        >
            <tspan x="517" y="190.8">$89</tspan>
        </text>
        <text
            fill="#667085"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
            text-decoration="line-through"
        >
            <tspan x="572" y="186.9">$99</tspan>
        </text>
        <path
            d="M358 262.5H469C473.142 262.5 476.5 265.858 476.5 270V286C476.5 290.142 473.142 293.5 469 293.5H358C353.858 293.5 350.5 290.142 350.5 286V270C350.5 265.858 353.858 262.5 358 262.5Z"
            fill="none"
            stroke="var(--et-colors-border)"
        />
        <path
            d="M24 262.5H135C139.142 262.5 142.5 265.858 142.5 270V286C142.5 290.142 139.142 293.5 135 293.5H24C19.8579 293.5 16.5 290.142 16.5 286V270C16.5 265.858 19.8579 262.5 24 262.5Z"
            fill="none"
        />
        <path
            d="M525 262.5H636C640.142 262.5 643.5 265.858 643.5 270V286C643.5 290.142 640.142 293.5 636 293.5H525C520.858 293.5 517.5 290.142 517.5 286V270C517.5 265.858 520.858 262.5 525 262.5Z"
            fill="none"
        />
        <path
            d="M525 262.5H636C640.142 262.5 643.5 265.858 643.5 270V286C643.5 290.142 640.142 293.5 636 293.5H525C520.858 293.5 517.5 290.142 517.5 286V270C517.5 265.858 520.858 262.5 525 262.5Z"
            stroke="var(--et-colors-border)"
        />
        <path
            d="M29.3337 314L22.0003 321.333L18.667 318M196.334 314L189 321.333L185.667 318M196.334 334L189 341.333L185.667 338M363.334 314L356 321.333L352.667 318M363.334 334L356 341.333L352.667 338M363.334 354L356 361.333L352.667 358M530.334 314L523 321.333L519.667 318M530.334 334L523 341.333L519.667 338M530.334 354L523 361.333L519.667 358M530.334 374L523 381.333L519.667 378"
            stroke="#079455"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M137 214H22C18.6863 214 16 216.686 16 220C16 223.314 18.6863 226 22 226H137C140.314 226 143 223.314 143 220C143 216.686 140.314 214 137 214Z"
            fill="#F2F4F7"
        />
        <path
            d="M109 234H22C18.6863 234 16 236.686 16 240C16 243.314 18.6863 246 22 246H109C112.314 246 115 243.314 115 240C115 236.686 112.314 234 109 234Z"
            fill="#F2F4F7"
        />
        <path
            d="M132 312H42C38.6863 312 36 314.686 36 318C36 321.314 38.6863 324 42 324H132C135.314 324 138 321.314 138 318C138 314.686 135.314 312 132 312Z"
            fill="#F2F4F7"
        />
        <path
            d="M114 332H42C38.6863 332 36 334.686 36 338C36 341.314 38.6863 344 42 344H114C117.314 344 120 341.314 120 338C120 334.686 117.314 332 114 332Z"
            fill="#F2F4F7"
        />
        <path
            d="M137 352H42C38.6863 352 36 354.686 36 358C36 361.314 38.6863 364 42 364H137C140.314 364 143 361.314 143 358C143 354.686 140.314 352 137 352Z"
            fill="#F2F4F7"
        />
        <path
            d="M88 372H42C38.6863 372 36 374.686 36 378C36 381.314 38.6863 384 42 384H88C91.3137 384 94 381.314 94 378C94 374.686 91.3137 372 88 372Z"
            fill="#F2F4F7"
        />
        <path
            d="M304 214H189C185.686 214 183 216.686 183 220C183 223.314 185.686 226 189 226H304C307.314 226 310 223.314 310 220C310 216.686 307.314 214 304 214Z"
            fill="#F2F4F7"
        />
        <path
            d="M241 234H189C185.686 234 183 236.686 183 240C183 243.314 185.686 246 189 246H241C244.314 246 247 243.314 247 240C247 236.686 244.314 234 241 234Z"
            fill="#F2F4F7"
        />
        <path
            d="M299 312H209C205.686 312 203 314.686 203 318C203 321.314 205.686 324 209 324H299C302.314 324 305 321.314 305 318C305 314.686 302.314 312 299 312Z"
            fill="#F2F4F7"
        />
        <path
            d="M281 332H209C205.686 332 203 334.686 203 338C203 341.314 205.686 344 209 344H281C284.314 344 287 341.314 287 338C287 334.686 284.314 332 281 332Z"
            fill="#F2F4F7"
        />
        <path
            d="M304 352H209C205.686 352 203 354.686 203 358C203 361.314 205.686 364 209 364H304C307.314 364 310 361.314 310 358C310 354.686 307.314 352 304 352Z"
            fill="#F2F4F7"
        />
        <path
            d="M255 372H209C205.686 372 203 374.686 203 378C203 381.314 205.686 384 209 384H255C258.314 384 261 381.314 261 378C261 374.686 258.314 372 255 372Z"
            fill="#F2F4F7"
        />
        <path
            d="M460 214H356C352.686 214 350 216.686 350 220C350 223.314 352.686 226 356 226H460C463.314 226 466 223.314 466 220C466 216.686 463.314 214 460 214Z"
            fill="#F2F4F7"
        />
        <path
            d="M419 234H356C352.686 234 350 236.686 350 240C350 243.314 352.686 246 356 246H419C422.314 246 425 243.314 425 240C425 236.686 422.314 234 419 234Z"
            fill="#F2F4F7"
        />
        <path
            d="M466 312H376C372.686 312 370 314.686 370 318C370 321.314 372.686 324 376 324H466C469.314 324 472 321.314 472 318C472 314.686 469.314 312 466 312Z"
            fill="#F2F4F7"
        />
        <path
            d="M448 332H376C372.686 332 370 334.686 370 338C370 341.314 372.686 344 376 344H448C451.314 344 454 341.314 454 338C454 334.686 451.314 332 448 332Z"
            fill="#F2F4F7"
        />
        <path
            d="M471 352H376C372.686 352 370 354.686 370 358C370 361.314 372.686 364 376 364H471C474.314 364 477 361.314 477 358C477 354.686 474.314 352 471 352Z"
            fill="#F2F4F7"
        />
        <path
            d="M422 372H376C372.686 372 370 374.686 370 378C370 381.314 372.686 384 376 384H422C425.314 384 428 381.314 428 378C428 374.686 425.314 372 422 372Z"
            fill="#F2F4F7"
        />
        <path
            d="M626 214H523C519.686 214 517 216.686 517 220C517 223.314 519.686 226 523 226H626C629.314 226 632 223.314 632 220C632 216.686 629.314 214 626 214Z"
            fill="#F2F4F7"
        />
        <path
            d="M586 234H523C519.686 234 517 236.686 517 240C517 243.314 519.686 246 523 246H586C589.314 246 592 243.314 592 240C592 236.686 589.314 234 586 234Z"
            fill="#F2F4F7"
        />
        <path
            d="M633 312H543C539.686 312 537 314.686 537 318C537 321.314 539.686 324 543 324H633C636.314 324 639 321.314 639 318C639 314.686 636.314 312 633 312Z"
            fill="#F2F4F7"
        />
        <path
            d="M615 332H543C539.686 332 537 334.686 537 338C537 341.314 539.686 344 543 344H615C618.314 344 621 341.314 621 338C621 334.686 618.314 332 615 332Z"
            fill="#F2F4F7"
        />
        <path
            d="M638 352H543C539.686 352 537 354.686 537 358C537 361.314 539.686 364 543 364H638C641.314 364 644 361.314 644 358C644 354.686 641.314 352 638 352Z"
            fill="#F2F4F7"
        />
        <path
            d="M589 372H543C539.686 372 537 374.686 537 378C537 381.314 539.686 384 543 384H589C592.314 384 595 381.314 595 378C595 374.686 592.314 372 589 372Z"
            fill="#F2F4F7"
        />
    </svg>
</template>
